module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("居住证业务")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.jzzbl()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-juzhuzhengbanli"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("居住证办理")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("外来人员居住证申领")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.jzzsb()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-juzhuzhengxinxishenbao"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("居住信息申报")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("外来人员居住信息填报申请")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f586b65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/residence_dialog/residence_dialog.vue
// module id = 307
// module chunks = 40